import "@/App.css";
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPages/RealEstate";
import LandingPageRoofingCompany from "@/pages/LandingPages/RoofingCompany";
import RoofingLightLanding from "@/pages/LandingPages/roofingLight/RoofingLightLanding";
import RoofingSpeedToLeadBenchmarkLanding from "@/pages/LandingPages/roofingSpeedToLeadBenchmark/RoofingSpeedToLeadBenchmarkLanding";
import { LANDING_PATHS } from "@/lib/landingPaths";
import LandingPageMarketingAgency from "@/pages/LandingPages/MarketingAgency";
import MainLanding from "@/pages/LandingPages/main/MainLanding";
import RootLanding from "@/pages/LandingPages/RootLanding";
import ContactPage from "@/pages/LandingPages/main/legal/ContactPage";
import PrivacyPolicyPage from "@/pages/LandingPages/main/legal/PrivacyPolicyPage";
import TermsPage from "@/pages/LandingPages/main/legal/TermsPage";
import DpaPage from "@/pages/LandingPages/main/legal/DpaPage";
import InterceptProtocol from "@/pages/LandingPages/InterceptProtocol";
import Dashboard from "@/pages/Dashboard";
import BotSettings from "@/pages/BotSettings/BotSettings";
import BotSchedule from "@/pages/BotSchedule/BotSchedule";
import WarmUpSequences from "@/pages/WarmUpSequences/WarmUpSequences";
import Login from "@/pages/Login";
import PasswordReset from "@/pages/PasswordReset";
import AccountSettings from "@/pages/AccountSettings";
import Listings from "@/pages/Listings";
import ChatTest from "@/pages/ChatTest";
import ChatWhatsApp from "@/pages/ChatWhatsApp";
import ChatTelegramApp from "@/pages/ChatTelegramApp";
import ChatGHL from "@/pages/ChatGHL";
import ChatWebWidget from "@/pages/ChatWebWidget";
import WhatsAppIntegration from "@/pages/integrations/messengers/WhatsAppIntegration";
import TelegramBotIntegration from "@/pages/integrations/messengers/TelegramBotIntegration";
import WebWidgetIntegration from "@/pages/integrations/web/WebWidgetIntegration";
import GoogleCalendar from "@/pages/integrations/calendars/GoogleCalendar";
import GoHighLevel from "@/pages/integrations/crm/GoHighLevel";
import Notifications from "@/pages/Notifications";
import Billing from "@/pages/Billing";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageMeta from "@/components/PageMeta";
import LeadTracking from "@/components/LeadTracking";
import StubLanding from "@/pages/LandingPages/stub/StubLanding";
import { unknownHostLeadRedirectUrl } from "@/lib/brandConfig";
import { getSiteBrand } from "@/lib/siteHosts";
import PartnerLayout from "@/pages/PartnerDashboard/layout/PartnerLayout";
import PartnerOverview from "@/pages/PartnerDashboard/pages/PartnerOverview";
import PartnerTiers from "@/pages/PartnerDashboard/pages/PartnerTiers";
import PartnerDeploy from "@/pages/PartnerDashboard/pages/PartnerDeploy";
import PartnerClients from "@/pages/PartnerDashboard/pages/PartnerClients";
import PartnerBilling from "@/pages/PartnerDashboard/pages/PartnerBilling";
import PartnerSettings from "@/pages/PartnerDashboard/pages/PartnerSettings";
import AdminLayout from "@/pages/AdminDashboard/layout/AdminLayout";
import AdminOverview from "@/pages/AdminDashboard/pages/AdminOverview";
import AdminUsersList from "@/pages/AdminDashboard/pages/AdminUsersList";
import AdminUserDetail from "@/pages/AdminDashboard/pages/AdminUserDetail";
import AdminLeadInquiries from "@/pages/AdminDashboard/pages/AdminLeadInquiries";
import AdminStripeAccounts from "@/pages/AdminDashboard/pages/AdminStripeAccounts";
import AdminTariffs from "@/pages/AdminDashboard/pages/AdminTariffs";
import AssumeSessionBanner from "@/pages/AdminDashboard/components/AssumeSessionBanner";
import { DASHBOARD_ROUTES } from "@/lib/dashboardRoutes";

const productRoutes = (
  <>
    <Route
      path="/admin"
      element={
        <ProtectedRoute requiredAccountType="admin" key="admin-shell">
          <AdminLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<AdminOverview />} />
      <Route path="users" element={<AdminUsersList />} />
      <Route path="users/:id" element={<AdminUserDetail />} />
      <Route path="leads" element={<AdminLeadInquiries />} />
      <Route path="stripe" element={<AdminStripeAccounts />} />
      <Route path="tariffs" element={<AdminTariffs />} />
    </Route>
    <Route
      path="/partner"
      element={
        <ProtectedRoute requiredAccountType="partner" key="partner-shell">
          <PartnerLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<PartnerOverview />} />
      <Route path="tiers" element={<PartnerTiers />} />
      <Route path="deploy" element={<PartnerDeploy />} />
      <Route path="clients" element={<PartnerClients />} />
      <Route path="billing" element={<PartnerBilling />} />
      <Route path="settings" element={<PartnerSettings />} />
    </Route>
    <Route
      path="/dashboard"
      element={
        <ProtectedRoute requiredAccountType="client" key="dashboard">
          <Dashboard />
        </ProtectedRoute>
      }
    />
    <Route
      path={DASHBOARD_ROUTES.settings}
      element={
        <ProtectedRoute requiredAccountType="client" key="digital-brain-settings">
          <BotSettings />
        </ProtectedRoute>
      }
    />
    <Route
      path={DASHBOARD_ROUTES.schedule}
      element={
        <ProtectedRoute requiredAccountType="client" key="digital-brain-schedule">
          <BotSchedule />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/bot-settings"
      element={<Navigate to={DASHBOARD_ROUTES.settings} replace />}
    />
    <Route
      path="/dashboard/bot-schedule"
      element={<Navigate to={DASHBOARD_ROUTES.schedule} replace />}
    />
    <Route
      path="/dashboard/warm-up-sequences"
      element={
        <ProtectedRoute requiredAccountType="client" key="warm-up-sequences">
          <WarmUpSequences />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/account-settings"
      element={
        <ProtectedRoute requiredAccountType="client" key="settings">
          <AccountSettings />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/listings"
      element={
        <ProtectedRoute requiredAccountType="client" key="listings">
          <Listings />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/chat-test"
      element={
        <ProtectedRoute requiredAccountType="client" key="chat-test">
          <ChatTest />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/chat-whatsapp"
      element={
        <ProtectedRoute requiredAccountType="client" key="chat-whatsapp">
          <ChatWhatsApp />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/chat-telegram"
      element={
        <ProtectedRoute requiredAccountType="client" key="chat-telegram">
          <ChatTelegramApp />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/chat-ghl"
      element={
        <ProtectedRoute requiredAccountType="client" key="chat-ghl">
          <ChatGHL />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/chat-web"
      element={
        <ProtectedRoute requiredAccountType="client" key="chat-web">
          <ChatWebWidget />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/integrations/messengers/whatsapp"
      element={
        <ProtectedRoute requiredAccountType="client" key="whatsapp-integration">
          <WhatsAppIntegration />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/integrations/messengers/telegram"
      element={
        <ProtectedRoute requiredAccountType="client" key="telegram-integration">
          <TelegramBotIntegration />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/integrations/web-widget"
      element={
        <ProtectedRoute requiredAccountType="client" key="web-widget-integration">
          <WebWidgetIntegration />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/integrations/calendars/google"
      element={
        <ProtectedRoute requiredAccountType="client" key="google-calendar-integration">
          <GoogleCalendar />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/integrations/crm/ghl"
      element={
        <ProtectedRoute requiredAccountType="client" key="ghl-integration">
          <GoHighLevel />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/notifications"
      element={
        <ProtectedRoute requiredAccountType="client" key="notifications">
          <Notifications />
        </ProtectedRoute>
      }
    />
    <Route
      path="/dashboard/billing"
      element={
        <ProtectedRoute requiredAccountType="client" key="billing">
          <Billing />
        </ProtectedRoute>
      }
    />
    <Route path="/login" element={<Login />} />
    <Route path="/password-reset" element={<PasswordReset />} />
  </>
);

function App() {
  return (
    <>
      <PageMeta />
      <BrandGate />
    </>
  );
}

function BrandGate() {
  if (!getSiteBrand()) return <UnknownHostScreen />;
  return (
    <>
      <LeadTracking />
      <AssumeSessionBanner />
      <Routes>
        <Route path="/" element={<RootLanding />} />
        <Route path="/lp/partner-landing" element={<LandingPageMarketingAgency />} />
        <Route path="/lp/roofing-landing" element={<LandingPageRoofingCompany />} />
        <Route path={LANDING_PATHS.roofingLight} element={<RoofingLightLanding />} />
        <Route path={LANDING_PATHS.roofingSpeedToLeadBenchmark} element={<RoofingSpeedToLeadBenchmarkLanding />} />
        <Route path="/lp/real-estate-landing" element={<LandingPage />} />
        <Route path="/lp/main-landing" element={<MainLanding />} />
        <Route path="/lp/intercept-protocol" element={<InterceptProtocol />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/dpa" element={<DpaPage />} />
        {productRoutes}
      </Routes>
    </>
  );
}

function UnknownHostScreen() {
  const { pathname, search } = useLocation();
  const redirectUrl = unknownHostLeadRedirectUrl(pathname, search);
  useEffect(() => {
    if (redirectUrl) window.location.replace(redirectUrl);
  }, [redirectUrl]);
  if (redirectUrl) return null;
  return <StubLanding />;
}

export default App;
